import { rootConfig } from "@p0security/integrations-gcloud-shared/util";
import type { Instructions } from "@p0security/shared/install/types";
import { Typography } from "@p0security/ui";
import type { ReactNode } from "react";

import type { GcloudInstaller } from "./types";

const { Paragraph } = Typography;

export const functionCallerInstructions: GcloudInstaller["components"]["function-caller"]["instructions"] =
  (context, id, item, _field): Instructions<ReactNode> => {
    const { serviceAccountEmail } = rootConfig(context.config);
    const { projectId, region } = item;

    return {
      help: (
        <Paragraph>
          To install function caller on this account, provision P0&apos;s access
          using{" "}
          <Typography.Link
            href={`https://console.cloud.google.com/cloudshelleditor?project=${projectId}&cloudshell=true`}
            target="_blank"
            rel="noopener"
          >
            Cloud Shell
          </Typography.Link>
        </Paragraph>
      ),
      commands: {
        shell: [
          {
            header: `Please execute the following commands and click 'Next':`,
            command: `# grants run.invoker to p0 service account
gcloud run services add-iam-policy-binding ${id} \\
  --member="serviceAccount:${serviceAccountEmail}" \\
  --region=${region} \\
  --role="roles/run.invoker"`,
          },
        ],
      },
    };
  };
